import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import { DataTypes, TemplateTypes } from '../../../../common/constants';
import SlbButton from "../../../controls/button";
import DataListing from '../../../listing/listing';
import { setButtonsData, setButtonsText } from "../../../../store/banner/bannerSlice";
import { useDispatch } from "react-redux";
import { getConfiguredLabel } from "../../../../common/commonHelper";
import { addButton, addRoleButton, addRoleTitle, addRoleTitleMessage, adminPage, adminTabName, cancelButton, deleteButton, deleteMessage, deleteNotAllowedMessage, deleteRoleTitle, deleteRoleTitleMessage, DocumentsPage, editRoleTitle, editRoleTitleMessage, roleTabName, saveButton } from "../../../../common/labelConstants";

export const Roles = (props) => {
    const editTemplate = 'editRoles'
    const dispatch = useDispatch();
    const handleRowClassName = (rowData) => {
        const rowClassName = rowData?.active?.hasOwnProperty("No")
        if (rowClassName) {
            return "admin_rowStyle"
        }
    }
    
    const addRole = () => {
        dispatch(setButtonsData(true))
    }

    const addRoleText = getConfiguredLabel(adminPage, addRoleButton);
    const bannerContent = {
        tabName: getConfiguredLabel(adminPage, adminTabName),
        actionsJSX: <>
            <div className='cancel-save-btns'>
                <SlbButton className='calcel_btn ' onClick={addRole}>{addRoleText}
                </SlbButton>
            </div>
        </>
    }
    useEffect(() => {
        dispatch(setButtonsText(bannerContent))
        return () => {
            dispatch(setButtonsText(''))
        }
    }, [])
    const actionToaster = {
        add: { title: getConfiguredLabel(adminPage, addRoleTitle), message: getConfiguredLabel(adminPage, addRoleTitleMessage) },
        edit: { title: getConfiguredLabel(adminPage, editRoleTitle), message: getConfiguredLabel(adminPage, editRoleTitleMessage) },
        delete: { title: getConfiguredLabel(adminPage, deleteRoleTitle), message: getConfiguredLabel(adminPage, deleteRoleTitleMessage), deleteNotAllowedMessage: getConfiguredLabel(adminPage, deleteNotAllowedMessage) }

    }
    return (
        <div className="dataRoles">
            <DataListing dataType_id={DataTypes.Roles.id}
                paginator={true}
                templateName={'roles'}
                rowClass={handleRowClassName}
                actionToaster={actionToaster}
                pageActionsInfo={{
                    add: { title: getConfiguredLabel(adminPage, addRoleTitle), message: '', actions: { ok: { label: getConfiguredLabel(DocumentsPage, addButton) }, cancel: { label: getConfiguredLabel(DocumentsPage, cancelButton) } } },
                    edit: { title: getConfiguredLabel(adminPage, editRoleTitle), message: '', actions: { ok: { label: getConfiguredLabel(DocumentsPage, saveButton) }, cancel: { label: getConfiguredLabel(DocumentsPage, cancelButton) } } },
                    delete: { title: getConfiguredLabel(adminPage, deleteRoleTitle), message: getConfiguredLabel(DocumentsPage, deleteMessage), actions: { ok: { label: getConfiguredLabel(DocumentsPage, deleteButton) }, cancel: { label: getConfiguredLabel(DocumentsPage, cancelButton) } } },
                }}
                // editDataTemplateName={editTemplate}
                // listDataTemplateName={TemplateTypes.roleslisting_table}
                renderHeaderAreaLeft={({ pagingInfo }) => {
                    return <>
                    {pagingInfo}
                    </>
                }}
                renderHeaderAreaRight={({ btn_delete, filter_global, orderBy_icon, sortBy_dropdown, add_item, selectedRows }) => {
                    return <>
                        {filter_global}
                        {btn_delete}
                        {sortBy_dropdown}
                        {/* {add_item(<SlbButton>Add Role</SlbButton>, 'Add Role')} */}
                    </>
                }}

            />
        </div>
    )
}